module.exports = __webpack_public_path__ + "bda358fc06115d7bc8bb9de3efa5f1eb.png";